import { USER_TYPE_CUSTOMER } from 'src/util/constants';

const isUserTypeCustomer = (userType) => userType === USER_TYPE_CUSTOMER;

export default isUserTypeCustomer;
